import React from 'react';
import {AppBar, Avatar, Button, IconButton, Toolbar, Typography} from '@mui/material';
import {useAuth0} from "@auth0/auth0-react";
import Logo from './../assets/GuruLogo.png';
import theme from "../theme";
import {Link} from "react-router-dom";

const TopBar = () => {
    const {
        loginWithRedirect,
        logout,
        user,
        isAuthenticated
    } = useAuth0();

    return (
        <AppBar position="relative" style={{
            zIndex: theme.zIndex.drawer + 1,
            backgroundColor: theme.palette.primary.dark,
            width: "100%"
        }}>
            <Toolbar sx={{padding: "0.5em"}}>
                <Link to={'/'}>
                    <img src={Logo} alt="logo" style={{
                        height: "64px",
                        border: "none",
                        borderRadius: "50%",
                    }}/>
                </Link>
                <Typography
                    variant="h6"
                    component="div"
                    sx={{
                        flexGrow: 1,
                        paddingLeft: "0.5em"
                }}>
                    Pizza Guru <i>alpha</i>
                </Typography>
                {isAuthenticated ? (
                    <IconButton color="inherit" onClick={() => logout()}>
                        <Avatar src={user?.picture} alt={user?.name}/>
                    </IconButton>
                ) : (
                    <Button color="inherit" onClick={() => loginWithRedirect()}>Login</Button>
                )}
            </Toolbar>
        </AppBar>
    );
}

export default TopBar;